

//utilities
// import moment from 'moment'
// import { rootDrawerMenuList, drawerMenuList } from '@/router'
// import { filter, cloneDeep, find, first, get, has, indexOf, isEmpty, merge, pick } from 'lodash'
// import api, {formatPhone } from '@/api' //api
// import { APP_ERROR } from './app'

import { cloneDeep, merge} from 'lodash'
import { defaultPaging } from '../Index' //updatePaging


// constants

export const RESET_PRODUCT_STATE = 'RESET_PRODUCT_STATE'
export const UPDATE_PRODUCT_STATE = 'UPDATE_PRODUCT_STATE'


// state
const moduleState = {
  isProcessing: false,
  isFetching: false,
  isFormAdd: false,
  isFormEdit: false,
  search: '',
  items: [
    {
      status: 'pending',
      name: 'Frozen Yogurt',
      calories: 159,
      fat: 6.0,
      carbs: 24,
      protein: 4.0,
      sources: [
        {
          name: 'Sales Floor',
          calories: 'Laptop',
          fat: 'D-22',
          carbs: '1274'
        },
        {
          name: 'Overstock',
          calories: 'Laptop',
          fat: 'D-22',
          carbs: '1274'
        },
        {
          name: 'Storage',
          calories: 'Laptop',
          fat: 'D-22',
          carbs: '1274'
        }
      ]
    },
    {
      status: 'active',
      name: 'Ice cream sandwich',
      calories: 237,
      fat: 9.0,
      carbs: 37,
      protein: 4.3,
      sources: [
        {
          name: 'Sales Floor',
          calories: 167,
          fat: 5.2,
          carbs: 25
        },
      ]
    },
    {
      status: 'inactive',
      name: 'Eclair',
      calories: 262,
      fat: 16.0,
      carbs: 23,
      protein: 6.0,
    },
    {
      status: 'active',
      name: 'Cupcake',
      calories: 305,
      fat: 3.7,
      carbs: 67,
      protein: 4.3,
    },
    {
      status: 'inactive',
      name: 'Gingerbread',
      calories: 356,
      fat: 16.0,
      carbs: 49,
      protein: 3.9,
    },
    {
      status: 'inactive',
      name: 'Jelly bean',
      calories: 375,
      fat: 0.0,
      carbs: 94,
      protein: 0.0,
    },
    {
      status: 'pending',
      name: 'Lollipop',
      calories: 392,
      fat: 0.2,
      carbs: 98,
      protein: 0,
    },
    {
      status: 'active',
      name: 'Honeycomb',
      calories: 408,
      fat: 3.2,
      carbs: 87,
      protein: 6.5,
    },
    {
      status: 'pending',
      name: 'Donut',
      calories: 452,
      fat: 25.0,
      carbs: 51,
      protein: 4.9,
    },
    {
      status: 'inactive',
      name: 'KitKat',
      calories: 518,
      fat: 26.0,
      carbs: 65,
      protein: 7,
    },
  ],
  item: {},
  paging: defaultPaging(),

}

// action

const actions = {

}

//Mutation
const mutations = {
  async [UPDATE_PRODUCT_STATE] (s, payload) {
    merge(s, payload)
    if (payload.items) s.items = [].concat(payload.items || [])
    if (payload.item) s.item = cloneDeep(payload.item)
  },
  async [RESET_PRODUCT_STATE] (s) {
    merge(s, cloneDeep(moduleState))
    s.items = []
    s.item = {}
  },
}

export default {
  state: () => cloneDeep(moduleState),
  actions,
  mutations,
}